import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DonorController } from "./donor.controller";
import { Donors } from "./donor.entity";
import { DonorService } from "./donor.service";
import { DonorAdapter } from "./dto/donor.adapter";


@Module({
  imports: [
    TypeOrmModule.forFeature([Donors]),
],
  controllers: [DonorController],
  providers: [DonorService,DonorAdapter],
  exports: [DonorService],
})
export class DonorsModule {}
